"use strict";
import Common from "./Common";
import Player from "./Player";
import Map from "./Map";
import Sprite3D from "./Sprite3D";
import Enemy from "./Enemy";
import AStar from "./AStar";
import SpriteRenderer from "./SpriteRenderer";

export default class GameScene3D extends P3.Scene {
    constructor() {
        super();

        /**
         * @type {number}
         * @private
         */
        this._resolution = Common.resolution = P3.View.width;

        /**
         * @type {Array}
         * @private
         */
        this._lines = [];

        /**
         * @type {Array}
         * @private
         */
        this._floorLines = []; //todo - finish implementing floors

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._gameHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._spHolder = Common.spriteHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         */
        this._uiHolder = new PIXI.Container();

        /**
         * @type {Map}
         * @private
         */
        this._map = new Map(25);

        /**
         * @type {Player}
         * @private
         */
        this._player = Common.player = new Player(this._map);

        //--create a duplicate for path finding algorithm--//
        let map = Common.map;
        let pathMap = Common.matrix(map.length, map.length);
        for (let i = 0; i < map.length; i++) {
            for (let j = 0; j < map.length; j++) {
                pathMap[i][j] = {occupied: null, pos: {x: i, y: j}};
                pathMap[i][j].blocked = (map[i][j] > 0);
            }
        }

        /**
         * @type {AStar}
         * @private
         */
        this._aStar = new AStar(pathMap);


        // console.log(path);


        const enemy = this._cat = new Enemy("enemy");
        enemy.x = 1.5;
        enemy.y = 1.5;
        let filter = new SpriteRenderer();
        enemy.view.filters = [filter];
        enemy.filter = filter;
        Common.sprites.push(enemy);
        Common.spriteHolder.addChild(enemy.view);
        Common.enemies.push(enemy);

        //--note always floor your position, this is because the sprites real position is in .5 increments (that's the centre of the square)
        let path = this._aStar.search({
            pos: {
                x: Math.floor(enemy.x),
                y: Math.floor(enemy.y)
            }
        }, {pos: {x: Math.floor(15), y: Math.floor(18)}});

        enemy.followPath(path);
    }

    init() {

        //--set renderer bg colour--//
        Common.renderer.backgroundColor = 0x000000;

        this.addChild(this._gameHolder, this._spHolder, this._uiHolder);

        this.initSky();//temp basic sky type effect (upper portion of screen is blue)

        //--init "slices", these are just pixi sprites that display a pixel wide slice of the texture--//
        this.initSlices(this._gameHolder);

        this.initUI();

        this._player.start();//--renders initial scene

        //--setup mouse input--//
        this._gameHolder.interactive = true;
        this._gameHolder.mousedown = this._gameHolder.touchstart = (event)=> {
            //  console.log("mouse down on screen");
            const inputData = event.data;
            const pos = inputData.getLocalPosition(this._gameHolder);
            this._player.shoot(pos);
        };

        //-test--//
        this._winTextView = P3.simpleText("YOU WIN!", "arial", 75, this._uiHolder);
        this._winTextView.anchor.set(0.5, 0.5);
        this._winTextView.position.set(P3.View.width * 0.5, P3.View.height * 0.5);
        this._winTextView.visible = false;
    }

    initSky() {
        //temporary basic floor and sky effect (untextured, tho could use a textured sprite for sky)
        const floor = P3.createSprite("floor", this._gameHolder);
        floor.width = P3.View.width;
        floor.height = floor.y = P3.View.height * 0.5;
        // floor.visible = false;

        this.floor = floor;

        const g = new PIXI.Graphics();
        g.beginFill(0x7EC0EE);
        g.drawRect(0, 0, 5, 5);
        g.endFill();

        const tex = Common.renderer.generateTexture(g);
        g.destroy();

        const sky = P3.createSprite(tex, this._gameHolder);
        sky.width = P3.View.width;
        sky.height = P3.View.height * 0.5;

        this.sky = sky;

        //sky.visible = false;
    }

    initSlices(gameHolder) {
        let slice;

        let upLines = [];

        // Create wall 'slice' sprites (for each ray)
        for (let x = 0; x < this._resolution; x++) {
            slice = new PIXI.Sprite(this._map.wallTextures[0][1]);//doesn't matter which texture we use here, is just for init, we will swap the textures later
            slice.x = x;
            gameHolder.addChild(slice);
            upLines.push(slice);
        }
        Common.upLines = upLines;


        // Create wall 'slice' sprites (for each ray)
        for (let x = 0; x < this._resolution; x++) {
            slice = new PIXI.Sprite(this._map.wallTextures[0][1]);//doesn't matter which texture we use here, is just for init, we will swap the textures later
            slice.x = x;
            gameHolder.addChild(slice);
            this._lines.push(slice);
        }
        Common.lines = this._lines;


        return;
        // floor slices along y axis
        for (let y = 0; y < P3.View.height; y++) {
            slice = new PIXI.Sprite(this._map.floorTextures[1]);
            slice.y = y;
            //slice.width = P3.View.width;
            gameHolder.addChild(slice);
            this._floorLines.push(slice);
        }
        Common.floorLines = this._floorLines;
    }

    update() {

        //--for adjusting sky / floor when the player jumps / crouches--//
        this.sky.height = (P3.View.height * 0.5) * this._player.yAdjust;
        this.floor.y = (P3.View.height * 0.5) * this._player.yAdjust;

        this._player.update();

        //--collide enemies and projectiles--//
        /*
         const len = Common.enemies.length, len2 = Common.projectiles.length;
         for (let i = 0; i < len; i++) {
         Common.enemies[i].update();
         for (let j = 0; j < len2; j++) {
         if (Common.distance(Common.enemies[i].x, Common.enemies[i].y, Common.projectiles[j].x, Common.projectiles[j].y) < 0.2) {
         //collision by distance is probably computationally expensive and also just not a good method
         //todo think of an improved method of collision detecting projectiles
         Common.enemies[i]._isDead = true;
         Common.enemies[i].view.visible = false;
         Common.enemies[i].view.renderable = false;
         Common.projectiles[j].view.visible = false;
         Common.projectiles[j].view.renderable = false;

         Common.enemies.splice(i, 1);
         Common.projectiles.splice(j, 1);

         return;//don't like this method, but also this return statement...
         }
         }
         }
         */

        //--depth sort sprite holder--//
        this._spHolder.children = Common.sortBy(this._spHolder.children, true);
    }

    initUI() {

        let moving = false;

        let upSprite = P3.createSprite("arrow", this._uiHolder);
        upSprite.anchor.set(0.5, 0);
        upSprite.interactive = true;
        upSprite.mousedown = upSprite.touchstart = ()=> {
            if (moving) {
                console.log("wait till current move is finished");
                return;
            }
            moving = true;
            // console.log(this._player.dirX + ", " + this._player.dirY);
            //facing = "up";
            const pos = {x: this._player.x, y: this._player.y};
            //  console.log(Math.round(this._player.dirX) + ", " + Math.round(this._player.dirY));
            if (Math.round(this._player.dirX) === 1 && Math.round(this._player.dirY) === 0) {
                console.log("facing up");
                pos.x++;
            } else if (Math.round(this._player.dirX) === 0 && Math.round(this._player.dirY) === 1) {
                console.log("facing left");
                pos.y++;
            } else if (Math.round(this._player.dirX) === 0 && Math.round(this._player.dirY) === -1) {
                console.log("facing right");
                pos.y--;
            } else if (Math.round(this._player.dirX) === -1 && Math.round(this._player.dirY) === 0) {
                console.log("facing down");
                pos.x--;
            }

            console.log(Math.round(pos.x) + ", " + Math.round(pos.y));
            //console.warn(this._map.grid[Math.round(pos.x)][Math.round(pos.y)]);

            if (this._map.grid[Math.floor(pos.x)][Math.floor(pos.y)] === 0) {
                this._player.moveTo(pos, ()=> {
                    moving = false;
                });
            } else {
                console.warn("that way is blocked");
                moving = false;
            }

            if (Math.round(pos.x) === Math.round(this._cat.x) && Math.round(pos.y) === Math.round(this._cat.y)) {
                console.log("caught the cat");
                this._winTextView.visible = true;
                delay(this.end, 2, this);
            }

        };

        upSprite.x = P3.View.width * 0.5;

        let lSprite = P3.createSprite("arrow", this._uiHolder);
        lSprite.anchor.set(0.5, 0);
        lSprite.rotation = -Math.PI * 0.5;
        lSprite.interactive = true;
        lSprite.mousedown = lSprite.touchstart = ()=> {
            if (moving) return;
            moving = true;
            console.log("rotating left");
            this._player.rotateTo(Math.PI * 0.5, ()=> {
                moving = false;
            });
        };
        lSprite.y = P3.View.height * 0.5;
        lSprite.x = lSprite.width * 0.5;

        let rSprite = P3.createSprite("arrow", this._uiHolder);
        rSprite.anchor.set(0.5, 0);
        rSprite.rotation = Math.PI * 0.5;
        rSprite.interactive = true;
        rSprite.mousedown = rSprite.touchstart = ()=> {
            if (moving) return;
            moving = true;
            console.log("rotating right");
            this._player.rotateTo(-Math.PI * 0.5, ()=> {
                moving = false;
            });
        };
        rSprite.y = P3.View.height * 0.5;
        rSprite.x = P3.View.width - rSprite.width * 0.5;

        upSprite.scale.x = lSprite.scale.x = rSprite.scale.x = 1.75;
        upSprite.scale.y = lSprite.scale.y = rSprite.scale.y = 1.75;
        upSprite.alpha = lSprite.alpha = rSprite.alpha = 0.5;
    }

    start() {

    }

    end() {
        this._running = false;
        this.signals.next.dispatch(this);
    }

    resize() {

    }

}